import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import JsBarcode from 'jsbarcode';

import './BetslipPopup.scss';

interface BetslipPopupRegisteredProps {
  onClose: () => void,
  onShare: () => void,
  code: string
}

export default function BetslipPopupRegistered({ onClose, onShare, code }: BetslipPopupRegisteredProps) {
  const { t } = useTranslation();
  const ref = useRef(null);

  const generateEan11 = (originalCode:string) => {
    const randomSuffixLength = 12 - originalCode.length - 1;
    const randomSuffix = Array.from({ length: randomSuffixLength }, () => 0).join('');

    const generatedCode = `5${ randomSuffix }${ originalCode }`;

    return generatedCode;
  };

  useEffect(() => {
    if (ref.current){
      const ean12 = generateEan11(code);
      JsBarcode(ref.current, ean12, { format: 'EAN13', displayValue: false });
    }
  }, [ref]);

  return (
    <div className="betslip-popup__content">
      <div className="betslip-popup__code">{ t('betslip.code') }: { code } </div>
      <svg
        className="betslip-popup__img"
        ref={ ref }
      />
      <div className="betslip-popup__buttons">
        <div
          onClick={ onShare }
          className="betslip-popup__btn"
        >
          { t('betslip.share') }
        </div>
        <div
          onClick={ onClose }
          className="betslip-popup__btn"
        >
          { t('betslip.ok') }
        </div>
      </div>
    </div>
  );
}
